import type { App } from 'vue'

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
import { ElLoading, ElScrollbar, ElPagination } from 'element-plus'

const plugins = [ElLoading]

const components = [ElScrollbar, ElPagination]

export const setupElementPlus = (app: App<Element>) => {
  // 注册插件
  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  // 优先注册全局组件，确保核心功能可用
  components.forEach((component) => {
    app.component(component.name!, component)
  })

  // 为了开发环境启动更快，一次性引入所有样式
  if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
    import('element-plus/dist/index.css')
  }
}
